<template>
  <div class="system-admins">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>管理员管理</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreate">添加管理员</el-button>
      </div>

      <el-table :data="list" border stripe v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="username" label="账号" width="150" />
        <el-table-column prop="real_name" label="姓名" width="120" />
        <el-table-column prop="phone" label="手机号" width="140" />
        <el-table-column prop="merchant_no" label="商户号" width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_no || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="merchant_name" label="商户名称" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_name || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="merchant_secret" label="商户密钥" min-width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_secret || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" min-width="180">
          <template slot-scope="scope">
            <el-tag v-for="r in scope.row.roles" :key="r.id" size="small" style="margin-right:4px">{{ r.name }}</el-tag>
            <span v-if="!scope.row.roles || scope.row.roles.length === 0" class="text-muted">未分配</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '正常' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="最后登录" width="160">
          <template slot-scope="scope">{{ scope.row.last_login_time | formatDateTime }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">{{ scope.row.create_time | formatDateTime }}</template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #E4393C" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap" v-if="total > 0">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="query.limit"
          :current-page.sync="query.page"
          @current-change="getList"
        />
      </div>
    </el-card>

    <!-- 添加/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="form.username" placeholder="请输入登录账号" maxlength="50" />
        </el-form-item>
        <el-form-item label="姓名" prop="real_name">
          <el-input v-model="form.real_name" placeholder="请输入真实姓名" maxlength="50" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" maxlength="20" />
        </el-form-item>
        <el-form-item label="商户号" prop="merchant_no">
          <el-input v-model="form.merchant_no" placeholder="请输入商户号" maxlength="64" />
        </el-form-item>
        <el-form-item label="商户名称" prop="merchant_name">
          <el-input v-model="form.merchant_name" placeholder="请输入商户名称" maxlength="100" />
        </el-form-item>
        <el-form-item label="商户密钥" prop="merchant_secret">
          <el-input v-model="form.merchant_secret" placeholder="请输入商户密钥" maxlength="255" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="留空则不修改密码" show-password />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="form.role_ids" multiple placeholder="请选择角色" style="width:100%" @change="handleRoleChange">
            <el-option v-for="r in roleOptions" :key="r.id" :label="r.name" :value="r.id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="showDelegatedAccount" label="委托账户" prop="delegated_company_id">
          <el-select v-model="form.delegated_company_id" placeholder="请选择绑定的委托账户" style="width:100%">
            <el-option v-for="c in delegatedCompanies" :key="c.id" :label="c.company_name" :value="c.id" />
          </el-select>
          <div class="form-tip">选择"委托管理"角色时必须绑定一个委托账户</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRbacAdmins, createRbacAdmin, updateRbacAdmin, deleteRbacAdmin, getRbacRolesAll, getRbacDelegatedCompanies } from '@/api'

export default {
  name: 'SystemAdmins',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: { page: 1, limit: 15 },
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      editId: null,
      submitLoading: false,
      roleOptions: [],
      delegatedCompanies: [],
      form: {
        username: '',
        real_name: '',
        phone: '',
        merchant_no: '',
        merchant_name: '',
        merchant_secret: '',
        password: '',
        status: 1,
        role_ids: [],
        delegated_company_id: null
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        real_name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码至少6位', trigger: 'blur' }
        ],
        delegated_company_id: [{ required: true, message: '请选择绑定的委托账户', trigger: 'change' }]
      }
    }
  },
  computed: {
    // 所选角色是否包含"委托管理"(slug=delegated_manager)
    showDelegatedAccount() {
      const delegatedRole = this.roleOptions.find(r => r.slug === 'delegated_manager')
      if (!delegatedRole) return false
      return this.form.role_ids.includes(delegatedRole.id)
    }
  },
  created() {
    this.getList()
    this.fetchRoleOptions()
    this.fetchDelegatedCompanies()
  },
  methods: {
    getList() {
      this.loading = true
      getRbacAdmins(this.query).then(res => {
        this.list = res.list || []
        this.total = res.total || 0
      }).finally(() => { this.loading = false })
    },
    fetchRoleOptions() {
      getRbacRolesAll().then(res => {
        this.roleOptions = res || []
      }).catch(() => {})
    },
    fetchDelegatedCompanies() {
      getRbacDelegatedCompanies().then(res => {
        this.delegatedCompanies = res || []
      }).catch(() => {})
    },
    handleRoleChange() {
      // 未选择委托管理角色时清空委托账户
      if (!this.showDelegatedAccount) {
        this.form.delegated_company_id = null
      }
    },
    resetForm() {
      this.form = { username: '', real_name: '', phone: '', merchant_no: '', merchant_name: '', merchant_secret: '', password: '', status: 1, role_ids: [], delegated_company_id: null }
    },
    handleCreate() {
      this.isEdit = false
      this.editId = null
      this.dialogTitle = '添加管理员'
      this.resetForm()
      this.rules.password[0].required = true
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.dialogTitle = '编辑管理员'
      this.form = {
        username: row.username,
        real_name: row.real_name || '',
        phone: row.phone || '',
        merchant_no: row.merchant_no || '',
        merchant_name: row.merchant_name || '',
        merchant_secret: row.merchant_secret || '',
        password: '',
        status: row.status,
        role_ids: (row.roles || []).map(r => r.id),
        delegated_company_id: row.delegated_company_id || null
      }
      this.rules.password[0].required = false
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleSubmit() {
      // 委托管理角色必须绑定委托账户
      if (this.showDelegatedAccount && !this.form.delegated_company_id) {
        this.$message.warning('请选择绑定的委托账户')
        return
      }
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const data = { ...this.form }
        if (!data.password) delete data.password

        const apiCall = this.isEdit
          ? updateRbacAdmin(this.editId, data)
          : createRbacAdmin(data)

        apiCall.then(() => {
          this.$message.success(this.isEdit ? '更新成功' : '创建成功')
          this.dialogVisible = false
          this.getList()
        }).catch(err => {
          this.$message.error(err.message || '操作失败')
        }).finally(() => { this.submitLoading = false })
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除管理员 "${row.username}"？`, '提示', { type: 'warning' }).then(() => {
        deleteRbacAdmin(row.id).then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}
.text-muted { color: #c0c4cc; }
.form-tip {
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
  margin-top: 4px;
}
</style>
